(function () {
  "use strict";

  angular.module("sempraWebapp").filter("chemicalIcon", chemicalIcon);

  /** @ngInject */
  function chemicalIcon() {
    return function (input) {
      switch (input) {
        case "CHEM_LEVEL_DRYING_AGENT":
          return "assets/images/rollover_drying.svg";
        case "CHEM_LEVEL_SHAMPOO":
          return "assets/images/rollover_shampoo.svg";
        case "CHEM_LEVEL_FOAM":
          return "assets/images/rollover_foam.svg"
        case "CHEM_LEVEL_WAX_1":
          return "assets/images/rollover_wax.svg";
        case "CHEM_LEVEL_POLISH_1":
          return "assets/images/rollover_polish.svg";
        case "CHEM_LEVEL_RIM_CLEANER":
          return "assets/images/rollover_rim_cleaner_11.svg";
        case "CHEM_LEVEL_WAX_2":
          return "assets/images/rollover_wax.svg";
        case "CHEM_LEVEL_TYRE_SHINE":
          return "assets/images/rollover_shampoo.svg";
        case "CHEM_LEVEL_INSECT_REMOVER":
          return "assets/images/rollover_insect_remover.svg";
        case "CHEM_LEVEL_POLISH_2":
          return "assets/images/rollover_polish.svg";
        case "CHEM_LEVEL_INTENSIVE":
          return "assets/images/rollover_shampoo.svg";
        case "CHEM_LEVEL_FOAM_RAIN":
          return "assets/images/rollover_foam_rain.svg";
        default:
          return "assets/images/rollover_shampoo.svg";
      }
    };
  }
})();
